import { DownloadFile, enqueueSnackbar, UploadFile } from 'actions';

import {
	GenerateBwUpdateRequest
} from '../requests/BwUpdateRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ProcessFileBwUpdate = (fileLocation, userId) => async (dispatch) => {
	await GenerateBwUpdateRequest(fileLocation, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GenerateBwScript = (file, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(ProcessFileBwUpdate(response.data, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
